// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2uXFZ","buttons":"SendReceipts_buttons__2fGlL","email":"SendReceipts_email__1m1lF","bookApptTitle":"SendReceipts_bookApptTitle__G6E5k"};